import { option } from "fp-ts";
import { DOMValueExtractor } from "../helpers/dom-value-extractors";
import { Failure } from "../helpers/failure";
import { SiteConfig } from "./main";

export function getSiteConfig(): SiteConfig {
  if (
    typeof UGApploader !== "undefined" &&
    UGApploader.installationType == "headless"
  ) {
    return {
      type: "app-loader",
      clientSpecificClass: UGApploader.installationClass,
      language: DOMValueExtractor.getLanguage(),
      apiBaseURL: UGApploader.apiEndpointUrl,
      pageId: option.fromNullable(safeUdstillerguideAccess()?.pageId),
    };
  }
  if (
    typeof udstillerguide !== "undefined" &&
    typeof UGApploader !== "undefined" &&
    UGApploader.installationType == "hosted"
  ) {
    return {
      type: "hosted",
      clientSpecificClass: UGApploader.installationClass,
      language: DOMValueExtractor.getLanguage(),
      apiBaseURL: DOMValueExtractor.getBaseUrl(),
      pageId: option.some(udstillerguide.pageId),
    };
  }
  if (typeof udstillerguide !== "undefined") {
    return {
      type: "hosted",
      clientSpecificClass: "",
      language: DOMValueExtractor.getLanguage(),
      apiBaseURL: DOMValueExtractor.getBaseUrl(),
      pageId: option.some(udstillerguide.pageId),
    };
  }
  Failure("Missing site config");
}

export function safeUdstillerguideAccess(): HostedSiteConfig | null {
  if (typeof udstillerguide === "undefined") return null;
  return udstillerguide;
}
